__turbopack_context__.v({
  "Active": "ServicesList-module-sass-module__9b_3IG__Active",
  "Cont": "ServicesList-module-sass-module__9b_3IG__Cont",
  "Content": "ServicesList-module-sass-module__9b_3IG__Content",
  "FullImage": "ServicesList-module-sass-module__9b_3IG__FullImage",
  "Image": "ServicesList-module-sass-module__9b_3IG__Image",
  "IsLight": "ServicesList-module-sass-module__9b_3IG__IsLight",
  "Main": "ServicesList-module-sass-module__9b_3IG__Main",
  "Reverse": "ServicesList-module-sass-module__9b_3IG__Reverse",
  "ReverseMain": "ServicesList-module-sass-module__9b_3IG__ReverseMain",
  "Service": "ServicesList-module-sass-module__9b_3IG__Service",
  "ServicesList": "ServicesList-module-sass-module__9b_3IG__ServicesList",
});
